import { useParams } from 'react-router-dom';
import CorePrivacyNoticePage from './CorePrivacyNoticePage';
import CscPrivacyNoticePage from './CscPrivacyNoticePage';
import GdadPrivacyNoticePage from './GdadPrivacyNoticePage';
import PsfaPrivacyNoticePage from './PsfaPrivacyNoticePage';
import ScsPrivacyNoticePage from './ScsPrivacyNoticePage';

function PrivacyNoticeScreen() {
  const { tenant } = useParams<{ tenant: string }>();

  switch ((tenant || '').toLowerCase()) {
    case 'core':
      return <CorePrivacyNoticePage />;
    case 'csc':
      return <CscPrivacyNoticePage />;
    case 'psfa':
      return <PsfaPrivacyNoticePage />;
    case 'scs':
      return <ScsPrivacyNoticePage />;
    case 'gdad':
      return <GdadPrivacyNoticePage />;
    default:
      return <CorePrivacyNoticePage />;
  }
}

export default PrivacyNoticeScreen;
